import { CheckoutBuyerAddress, GetCheckoutV2Props, GetCheckoutV2Response } from 'types';
import { useState, useEffect } from 'react';
import { backendFunction } from '@/clients/firebase/client';
import { useGlobalState } from '@/state';
import ExpressCheckout from './express-checkout';
import { loadStripe } from '@stripe/stripe-js';
import useAnalytics from '../../lib/hooks/use-analytics';

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY);

interface ExpressCheckoutPluginProps {
  bookIds: string[];
  setExpressPaymentAvailable?: (show: boolean) => void;
}
export default function ExpressCheckoutPlugin({ bookIds, setExpressPaymentAvailable }: ExpressCheckoutPluginProps) {
  const { state } = useGlobalState();
  const [checkoutData, setCheckoutData] = useState<GetCheckoutV2Response>(null);
  const { analyticEvents, analyticsLoaded } = useAnalytics();

  useEffect(() => {
    if (!state?.user?.data?.uid || !bookIds?.length) return;
    backendFunction<GetCheckoutV2Response, GetCheckoutV2Props>('checkout-getCheckoutV2', {
      bookIds: bookIds,
      uid: state?.user?.data?.uid,
      type: 'express',
      web: true
    }).then(_data => {
      setCheckoutData(_data);
    });
  }, [state?.user?.data?.uid, bookIds]);

  // temp: log ab test group
  // useEffect(() => {
  //   if (!analyticEvents || !analyticsLoaded || !checkoutData?.shouldLogTestGroup?.testGroup || !state?.user?.data?.uid) return;
  //   analyticEvents.generalTrack('AB Test Group', {
  //     properties: {
  //       testId: checkoutData?.shouldLogTestGroup?.testId,
  //       testGroup: checkoutData?.shouldLogTestGroup?.testGroup,
  //     }
  //   });
  // }, [checkoutData, analyticEvents, analyticsLoaded, state?.user?.data?.uid]);

  async function updateCheckoutWithShipping({ buyerAddress }: { buyerAddress: CheckoutBuyerAddress; }) {
    const updatedCheckoutData = await backendFunction<GetCheckoutV2Response, GetCheckoutV2Props>('checkout-getCheckoutV2', {
      bookIds: bookIds,
      uid: state?.user?.data?.uid,
      type: 'express',
      web: true,
      buyerAddress
    });
    setCheckoutData(updatedCheckoutData);
    return updatedCheckoutData;
  }

  if (!checkoutData) return null;

  return (
    <ExpressCheckout
      key={bookIds?.join('-')}
      checkoutData={checkoutData}
      stripePromise={stripePromise}
      updateCheckout={updateCheckoutWithShipping}
      onReady={event => {
        if (event.availablePaymentMethods && setExpressPaymentAvailable) {
          setExpressPaymentAvailable(true);
        }
      }}
    />
  );
}